import React from "react";
import { uploadFile } from "react-s3";
import { useDispatch, useSelector } from "react-redux";
import logoLibrary from "../../../../../../services/logoLibrary";
import { defaultLogoItem } from "../../../../../../services/excelDataToProjectData";
import {
  MdOutlineRemoveCircleOutline,
  MdOutlineModeEditOutline,
} from "react-icons/md";

import {
  EC_FileInput,
  EC_NumberInput,
  EC_TextInput,
} from "../../../../../../UiComponents";

import {
  updateProjectCreditOptionsState,
  saveOptionById,
  updateProjectCreditItems,
  updateAProjectCreditItemsState,
  uploadLogoDetails,
  undoOptions,
  redoOptions,
} from "../../../../../../Redux/actions/projectActions";
import {
  BlockType,
  Heading,
  Subheading,
  MarginBottom,
  BlockInset,
  SideBySide,
} from "../Functions";
import { useEffect, useState } from "react";

window.Buffer = window.Buffer || require("buffer").Buffer;

const config = {
  bucketName: "elementscut",
  region: "ap-south-1",
  accessKeyId: "AKIA6LMZYPI3RLCYWVAN",
  secretAccessKey: "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",
  dirName: "logos",
};

const getValue = (value) => {
  return value ? value : "";
};

export default function Logo({ props, options, undoStack }) {
  const { currentBlockIdx, currentBlockId, credit } = props;
  const [editLogoIdx, setEditLogoIdx] = useState(null);

  useEffect(() => {
    if (credit.items.length === 4) return;
    if (credit.items.length > 4) credit.items.splice(4);
    const items = credit.items;
    while (items.length !== 4) {
      items.push({ logo: defaultLogoItem });
    }
    dispatch(updateAProjectCreditItemsState(credit._id, items));
  });

  const dispatch = useDispatch();
  const changeOptionValue = (key, value) => {
    dispatch(updateProjectCreditOptionsState(currentBlockIdx, key, value));
  };

  const saveOption = () => {
    undoStack.push(options);
    dispatch(saveOptionById(currentBlockId));
  };

  const handleLibraryLogoClick = (thumbnail, url) => {
    const vacantSpaceidx = credit.items.findIndex(
      (item) => !item.logo.thumbnail && !item.logo.url
    );

    if (vacantSpaceidx === -1) return;
    credit.items[vacantSpaceidx].logo = {
      ...credit.items[vacantSpaceidx].logo,
      thumbnail,
      url,
    };
    dispatch(updateProjectCreditItems(credit._id, credit.items));
  };

  const handlePreviewLogoRemove = (idx) => {
    const items = credit.items;
    items[idx].logo = defaultLogoItem;
    dispatch(updateProjectCreditItems(credit._id, items));
  };

  const handleLogoUpload = (file) => {
    const fileName = file.name;
    const newFile = new File([file], file.name + Date.now(), {
      type: file.type,
    });

    uploadFile(newFile, config)
      .then((data) =>
        dispatch(
          uploadLogoDetails({
            name: fileName,
            url: data.location,
            thumbnail: data.location,
          })
        )
      )
      .catch((err) => console.error(err));
  };

  const LogoPreview = ({ items, removeLogo, editLogo }) => {
    return (
      <div className="flex flex-nowrap overflow-x-auto">
        <div className="flex justify-end">
          <button
            style={{ color: "white", margin: "5px" }}
            disabled={undoStack.getPosition < 1}
            onClick={() => dispatch(undoOptions(currentBlockId))}
          >
            undo
          </button>
          <button
            style={{ color: "white", margin: "5px" }}
            disabled={
              undoStack.getPosition === -1 ||
              undoStack.getPosition === undoStack.getData.length - 1
            }
            onClick={() => dispatch(redoOptions(currentBlockId))}
          >
            redo
          </button>
        </div>
        {items.map(({ logo }, idx) => {
          return (
            <div style={{ width: "120px", height: "120px" }}>
              {logo.url || logo.thumbnail ? (
                <div>
                  <img
                    style={{ width: "85px", height: "85px", margin: "auto" }}
                    key={idx}
                    src={logo.thumbnail ? logo.thumbnail : logo.url}
                  />
                  <div className="flex justify-around	">
                    <div
                      className="hover:bg-red-400 flex justify-center w-2/5 cursor-pointer"
                      onClick={() => removeLogo(idx)}
                    >
                      <MdOutlineRemoveCircleOutline />
                    </div>
                    <div
                      className="hover:bg-yellow-400 flex justify-center w-2/5 cursor-pointer"
                      onClick={() => editLogo(idx)}
                    >
                      <MdOutlineModeEditOutline />
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="bg-slate-200"
                  style={{ width: "80%", height: "80%" }}
                ></div>
              )}
            </div>
          );
        })}
      </div>
    );
  };
  const LogoLibrary = ({ logos, handleClick, handleLogoUpload }) => {
    const projectLogos = useSelector((state) => state.project.logos);
    logos = [...logos, ...projectLogos];
    const [filterQuery, setFilterQuery] = useState("");
    logos = logos.filter((logo) =>
      filterQuery
        .split(" ")
        .some(
          (subQuery) =>
            logo.name
              .toLowerCase()
              .replace(" ", "")
              .indexOf(subQuery.toLowerCase()) > -1
        )
    );
    return (
      <>
        <div className="flex">
          <EC_TextInput
            label="Search Logo"
            value={filterQuery}
            onChange={(val) => {
              setFilterQuery(val);
            }}
          />
          <EC_FileInput
            label="Upload Logo"
            accept="image/*"
            handleFileInput={handleLogoUpload}
          />
        </div>
        <div className="flex flex-nowrap overflow-x-auto">
          {logos.map((logo, idx) =>
            logo.url || logo.thumbnail ? (
              <img
                key={idx}
                onClick={() => handleClick(logo.thumbnail, logo.url)}
                className="p-2"
                style={{ width: "100px", height: "100px" }}
                src={logo.thumbnail ? logo.thumbnail : logo.url}
              />
            ) : null
          )}
        </div>
      </>
    );
  };

  const handleLogoDetailsSave = (key, value) => {
    const items = credit.items;
    items[editLogoIdx].logo[key] = value;
    dispatch(updateProjectCreditItems(credit._id, items));
  };

  //TODO: Save details in db and add onchange to update state.
  const EditLogoDetails = ({ logoDetails, closeEditBlock, saveDetails }) => {
    const { scale, offset_x, offset_y } = logoDetails;
    const [logoState, setLogoState] = useState({
      offset_x,
      offset_y,
      scale,
    });
    const handleChange = (key, val) => {
      setLogoState({ ...logoState, [key]: val });
    };
    return (
      <div className="mx-2 border-y-2 border-slate-400">
        <div
          className="flex justify-end p-2 mr-5 cursor-pointer "
          onClick={closeEditBlock}
        >
          X
        </div>
        <EC_NumberInput
          label="X Offset"
          min={0}
          max={200}
          step={1}
          value={logoState.offset_x}
          onChange={(val) => {
            handleChange("offset_x", parseInt(val));
          }}
          onFocusOut={(e) => {
            saveDetails("offset_x", parseInt(e.target.value));
          }}
        />
        <EC_NumberInput
          label="Y Offset"
          min={0}
          max={200}
          step={1}
          value={logoState.offset_y}
          onChange={(val) => {
            handleChange("offset_y", parseInt(val));
          }}
          onFocusOut={(e) => {
            saveDetails("offset_y", parseInt(e.target.value));
          }}
        />
        <EC_NumberInput
          label="Scale"
          min={25}
          max={200}
          step={5}
          value={logoState.scale}
          onChange={(val) => {
            handleChange("scale", val);
          }}
          onFocusOut={(e) => {
            saveDetails("scale", e.target.value);
          }}
        />
      </div>
    );
  };

  return (
    <div className="text-slate-200 w-full">
      <BlockType
        value={options.block_type}
        onChange={(val) => {
          changeOptionValue("block_type", val);
          saveOption();
        }}
      />

      <LogoPreview
        items={credit.items}
        removeLogo={handlePreviewLogoRemove}
        editLogo={(idx) => setEditLogoIdx(idx)}
      />

      {editLogoIdx !== null ? (
        <EditLogoDetails
          key={editLogoIdx}
          logoDetails={credit.items[editLogoIdx].logo}
          closeEditBlock={() => setEditLogoIdx(null)}
          saveDetails={handleLogoDetailsSave}
        />
      ) : (
        <>
          <LogoLibrary
            logos={logoLibrary}
            handleClick={handleLibraryLogoClick}
            handleLogoUpload={handleLogoUpload}
          />

          <Heading
            onChange={(val) => {
              changeOptionValue("heading", val);
            }}
            value={getValue(options.heading)}
            onFocusOut={saveOption}
          />
          <Subheading
            onChange={(val) => {
              changeOptionValue("subheading", val);
            }}
            value={getValue(options.subheading ? options.subheading : "")}
            onFocusOut={saveOption}
          />
          <MarginBottom
            value={options.extra_lines_below}
            onChange={(val) => {
              changeOptionValue(
                "extra_lines_below",
                parseInt(val > 0 ? val : 0)
              );
            }}
            onFocusOut={saveOption}
          />

          <BlockInset
            value={options.block_inset}
            onChange={(val) => {
              changeOptionValue("block_inset", val);
              saveOption();
            }}
          />
          <SideBySide
            value={options.side_by_side}
            onChange={(val) => {
              changeOptionValue("side_by_side", val);
              saveOption();
            }}
          />
        </>
      )}
    </div>
  );
}
